import { render, staticRenderFns } from "./HomeBuffalo.vue?vue&type=template&id=fdc6ee7a&"
import script from "./HomeBuffalo.vue?vue&type=script&lang=ts&"
export * from "./HomeBuffalo.vue?vue&type=script&lang=ts&"
import style0 from "./HomeBuffalo.vue?vue&type=style&index=0&id=fdc6ee7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports